<template>
  <b-tabs class="mt-4">
    <b-tab title="Benutzer" active>
      <b-row class="mt-3">
        <b-col>
          <b-button variant="primary" class="float-right" @click="printBenutzerAsPDF">Benutzer als PDF drucken</b-button>
        </b-col>
      </b-row>
      <b-form @submit.prevent="benutzerBearbeiten" class="text-left">
        <b-form-row class="my-4">
          <b-col>
            <b-form-checkbox
              id="benutzer_aktiv"
              v-model="benutzer.isActive"
              value="1"
              unchecked-value="0"
            > Aktiv</b-form-checkbox>
          </b-col>
          <b-col>
            <b-form-checkbox
              id="benutzer_admin"
              v-model="benutzer.admin"
              value="1"
              unchecked-value="0"
            > Admin </b-form-checkbox>
          </b-col>
        </b-form-row>

        <hr>

        <b-form-row>
          <b-col>
            <b-form-group id="vorname-group" label="Vorname *" label-for="vorname">
              <b-form-input
                id="vorname"
                v-model="benutzer.vorname"
                type="text"
                :state="vornameState"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <b-form-group id="name-group" label="Name *" label-for="name">
              <b-form-input
                id="name"
                v-model="benutzer.name"
                type="text"
                :state="nameState"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <b-form-group id="anmeldename-group" label="Anmeldename *" label-for="anmeldename">
              <b-form-input
                id="anmeldename"
                v-model="benutzer.anmeldename"
                type="text"
                :state="anmeldenameState"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group id="email-group" label="E-Mail Adresse" label-for="email">
              <b-form-input
                id="email"
                v-model="benutzer.email"
                type="email"
                :state="emailState"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-row>
          <b-col>
            <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
          </b-col>
        </b-row>
      </b-form>

      <hr class="my-4">

      <b-form @submit.prevent="passwortÄndern()" class="text-left">
        <b-form-group
          id="passwort-group"
          label="Passwort"
          label-for="passwort"
        >
          <b-form-input
            id="passwort"
            v-model="benutzer.passwort"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
        <div>
          <b-button
            @click="$bvModal.hide(`benutzerBearbeiten`)"
            variant="secondary"
            class="mr-3"
          >Abbrechen</b-button>
          <b-button type="submit" variant="success" class="float-right">Passwort ändern</b-button>
        </div>
      </b-form>

      <p class="text-center mt-5 text-secondary">Weitere Benutzerinformationen</p>
      <hr class="my-4">

      <b-form @submit.prevent="benutzerBearbeiten" class="text-left">
        <b-form-row>
          <b-col>
            <b-form-group id="anrede-group" label="Anrede" label-for="anrede">
              <b-form-select
                id="anrede"
                v-model="benutzer.geschlecht"
                :state="geschlechtState"
              >
                <option value="m">Herr</option>
                <option value="w">Frau</option>
                <option value="d">Sonstige</option>
              </b-form-select>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <b-form-group id="geburtsdatum-group" label="Geburtsdatum" label-for="geburtsdatum">
              <b-form-input
                id="geburtsdatum *"
                v-model="date"
                type="date"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <hr class="my-4">

        <b-form-row>
          <b-col>
            <b-form-group
              id="strasse-group"
              label="Straße und Hausnummer"
              label-for="strasse"
            >
              <b-form-input
                id="strasse"
                v-model="benutzer.strasse"
                type="text"
                :state="strasseState"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col cols="4">
            <b-form-group id="plz-group" label="PLZ" label-for="plz">
              <b-form-input
                id="plz"
                v-model="benutzer.plz"
                type="text"
                :state="plzState"
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="8">
            <b-form-group id="ort-group" label="Ort" label-for="ort">
              <b-form-input
                id="ort"
                v-model="benutzer.ort"
                type="text"
                :state="ortState"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <b-form-row>
          <b-col>
            <b-form-group id="land-group" label="Land" label-for="land">
              <b-form-input
                id="land"
                v-model="benutzer.land"
                type="text"
                :state="landState"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <hr class="my-4">

        <b-form-row>
          <b-col cols="5">
            <b-form-group id="tel-group" label="Telefonnummer" label-for="tel">
              <b-form-input
                id="tel"
                v-model="benutzer.tel"
                type="text"
                :state="telState"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="fax-group" label="Fax" label-for="fax">
              <b-form-input id="fax" v-model="benutzer.fax" type="text" :state="faxState"></b-form-input>
            </b-form-group>

            <b-form-group id="mobil-group" label="Mobilnummer" label-for="mobil">
              <b-form-input id="mobil" v-model="benutzer.mobil" type="text" :state="mobilState"></b-form-input>
            </b-form-group>
          </b-col>
          <b-col cols="5" offset="2">
            <b-form-group id="telG-group" label="Telefonnummer 2" label-for="telG">
              <b-form-input id="telG" v-model="benutzer.telG" type="text" :state="telGState"></b-form-input>
            </b-form-group>

            <b-form-group id="faxG-group" label="Fax 2" label-for="faxG">
              <b-form-input id="faxG" v-model="benutzer.faxG" type="text" :state="faxGState"></b-form-input>
            </b-form-group>

            <b-form-group id="mobilG-group" label="Mobilnummer 2" label-for="mobilG">
              <b-form-input
                id="mobilG"
                v-model="benutzer.mobilG"
                type="text"
                :state="mobilGState"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="emailG-group" label="E-Mail Adresse 2" label-for="emailG">
              <b-form-input
                id="emailG"
                v-model="benutzer.emailG"
                type="email"
                :state="emailGState"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <hr class="my-4">

        <b-row>
          <b-col>
            <b-button
              @click="$bvModal.hide(`benutzerBearbeiten`)"
              variant="secondary"
              class="mr-3"
            >Abbrechen</b-button>
            <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-tab>

    <b-tab title="Funktionen">
      <b-form @submit.prevent="saveFunctionChanges" class="mt-4">
        <b-form-checkbox
          :id="`sicherheit-checkbox`"
          v-model="benutzer.funktionen.sicherheit"
          value="1"
          unchecked-value="0"
        >Startseite</b-form-checkbox>

        <b-form-checkbox
          :id="`gesundheit-checkbox`"
          v-model="benutzer.funktionen.gesundheit"
          value="1"
          unchecked-value="0"
        >Rollator</b-form-checkbox>

        <b-form-checkbox
          :id="`Unterhaltung-checkbox`"
          v-model="benutzer.funktionen.unterhaltung"
          value="1"
          unchecked-value="0"
        >Unterhaltung</b-form-checkbox>

        <b-form-checkbox
          :id="`kommunikation-checkbox`"
          v-model="benutzer.funktionen.kommunikation"
          value="1"
          unchecked-value="0"
        >Kommunikation</b-form-checkbox>

        <b-form-checkbox
          :id="`einstellungen-checkbox`"
          v-model="benutzer.funktionen.einstellungen"
          value="1"
          unchecked-value="0"
        >Einstellungen</b-form-checkbox>

        <div class="mt-3">
          <b-button
            @click="$bvModal.hide(`benutzerBearbeiten`)"
            variant="secondary"
            class="mr-3"
          >Abbrechen</b-button>
          <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
        </div>
      </b-form>
    </b-tab>

    <b-tab title="SMS Provider">
      <b-form @submit.prevent="createSmsProvider" class="text-left mt-4">
        <b-form-group id="sms-host-group" label="Host" label-for="sms-host">
          <b-form-input id="sms-host" v-model="benutzer.smsHost" type="text" />
        </b-form-group>

        <b-form-group id="sms-benutzer-id-group" label="Benutzer Id" label-for="benutzer-id">
          <b-form-input id="benutzer-id" v-model="benutzer.smsUserId" type="text" />
        </b-form-group>

        <b-form-group id="sms-api-key-group" label="Api Key" label-for="api-key">
          <b-form-input id="api-key" v-model="benutzer.smsApiKey" type="password" />
        </b-form-group>

        <div>
          <b-button
            @click="$bvModal.hide(`benutzerBearbeiten`)"
            variant="secondary"
            class="mr-3"
          >Abbrechen</b-button>
          <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
        </div>
      </b-form>
    </b-tab>

    <b-tab title="Email Client">
      <b-form @submit.prevent="benutzerBearbeiten" class="text-left">
        <b-form-row>
          <b-col class="mr-4">
            <h4>SMTP</h4>
            <b-form-group id="smtp-server-group" label="SMTP Server" label-for="smtp-server">
              <b-form-input id="smtp-server" v-model="benutzer.smtpServer" type="text"></b-form-input>
            </b-form-group>
            
            <b-form-group id="smtp-port-group" label="SMTP Port" label-for="smtp-port">
              <b-form-input
                id="smtp-port"
                v-model="benutzer.smtpPort"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="smtp-username-group" label="SMTP Benutzername" label-for="smtp-username">
              <b-form-input
                id="smtp-username"
                v-model="benutzer.smtpUsername"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="smtp-password-group" label="SMTP Passwort" label-for="smtp-password">
              <b-form-input
                id="smtp-password"
                v-model="benutzer.smtpPassword"
                type="password"
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col>
            <h4>POP 3</h4>
            <b-form-group id="pop-server-group" label="POP3 Server" label-for="pop-server">
              <b-form-input id="pop-server" v-model="benutzer.popServer" type="text"></b-form-input>
            </b-form-group>
            
            <b-form-group id="pop-port-group" label="POP3 Port" label-for="pop-port">
              <b-form-input
                id="pop-port"
                v-model="benutzer.popPort"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="pop-username-group" label="POP3 Benutzername" label-for="pop-username">
              <b-form-input
                id="pop-username"
                v-model="benutzer.popUsername"
                type="text"
              ></b-form-input>
            </b-form-group>

            <b-form-group id="pop-password-group" label="POP3 Passwort" label-for="pop-password">
              <b-form-input
                id="pop-password"
                v-model="benutzer.popPassword"
                type="password"
              ></b-form-input>
            </b-form-group>
          </b-col>
        </b-form-row>

        <div>
          <b-button
            @click="$bvModal.hide(`benutzerBearbeiten`)"
            variant="secondary"
            class="mr-3"
          >Abbrechen</b-button>
          <b-button type="submit" variant="success" class="float-right">Speichern</b-button>
        </div>
      </b-form>
    </b-tab>

    <!-- <b-tab title="Bild"  class="mt-4">
      <b-row>
        <b-col>
          <div
            v-if="adminStatus.gettingUserImage || adminStatus.uploadingUserImage"
            class="text-center"
          >
            <b-spinner variant="primary" type="grow"></b-spinner>
          </div>
          <div v-else class="text-center">
            <b-img
              v-if="benutzerBild"
              thumbnail
              fluid
              :src="`data:${benutzerBild.contentType};base64,${benutzerBild.image}`"
              alt="Profil Bild"
              class="mb-3 img-size"
            ></b-img>
            <b-img
              v-else
              thumbnail
              fluid
              :src="require('../../../assets/profile.png')"
              alt="file 1"
            ></b-img>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-form-file
            v-model="file"
            placeholder="Wählen Sie ein Profilbild"
            class="mb-2"
            accept="image/*"
          ></b-form-file>
          <b-button
            v-if="file"
            variant="primary"
            @click="uploadBild"
            class="float-right"
          >Bild hochladen</b-button>
        </b-col>
      </b-row>
    </b-tab> -->

    <b-tab title="Konto löschen"  class="mt-4 pt-5">
      <b-button variant="danger" @click="benutzerLoeschen()" class="mr-2 mt-4">Konto löschen</b-button>
    </b-tab>
  </b-tabs>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { jsPDF } from "jspdf";

export default {
  name: "BenutzerBearbeiten",
  props: ["benutzer"],
  computed: {
    ...mapGetters(["adminStatus", "benutzerBild"]),
    geschlechtState() {
      if (this.benutzer.geschlecht === null) {
        return null;
      } else if (
        this.benutzer.geschlecht.toLowerCase() === "m" ||
        this.benutzer.geschlecht.toLowerCase() === "w" ||
        this.benutzer.geschlecht.toLowerCase() === "d"
      ) {
        return true;
      } else {
        return false;
      }
    },
    anmeldenameState() {
      if (this.benutzer.anmeldename === "" || this.benutzer.anmeldename === null) return null;

      return this.benutzer.vorname.length > 0 ? true : false;
    },
    vornameState() {
      if (this.benutzer.vorname === "" || this.benutzer.vorname === null) return null;

      return this.benutzer.vorname.length > 0 ? true : false;
    },
    nameState() {
      if (this.benutzer.name === "" || this.benutzer.name === null) return null;

      return this.benutzer.name.length > 0 ? true : false;
    },
    geburtstadumState() {
      if (this.benutzer.geburtsdatum === "" || this.benutzer.geburtsdatum === null) return null;

      return true;
    },
    strasseState() {
      if (this.benutzer.strasse === "" || this.benutzer.strasse === null) return null;

      return this.benutzer.strasse.length > 0 ? true : false;
    },
    plzState() {
      if (this.benutzer.plz === "" || this.benutzer.plz === null) return null;

      return this.benutzer.plz.length > 0 ? true : false;
    },
    ortState() {
      if (this.benutzer.ort === "" || this.benutzer.ort === null) return null;

      return this.benutzer.ort.length > 0 ? true : false;
    },
    landState() {
      if (this.benutzer.land === "" || this.benutzer.land === null) return null;

      return this.benutzer.land.length > 0 ? true : false;
    },
    telState() {
      if (this.benutzer.tel === "" || this.benutzer.tel === null) return null;

      return this.benutzer.tel.length > 0 ? true : false;
    },
    faxState() {
      if (this.benutzer.fax === "" || this.benutzer.fax === null) return null;

      return this.benutzer.fax.length > 0 ? true : false;
    },
    mobilState() {
      if (this.benutzer.mobil === "" || this.benutzer.mobil === null) return null;

      return this.benutzer.mobil.length > 0 ? true : false;
    },
    emailState() {
      if (this.benutzer.email === "" || this.benutzer.email == null) return null;

      return this.emailRegex.test(this.benutzer.email) ? true : false;
    },
    telGState() {
      if (this.benutzer.telG === "" || this.benutzer.telG === null) return null;

      return this.benutzer.telG.length > 0 ? true : false;
    },
    faxGState() {
      if (this.benutzer.faxG === "" || this.benutzer.faxG === null) return null;

      return this.benutzer.faxG.length > 0 ? true : false;
    },
    mobilGState() {
      if (this.benutzer.mobil === "" || this.benutzer.mobil === null) return null;

      return this.benutzer.mobil.length > 0 ? true : false;
    },
    emailGState() {
      if (this.benutzer.emailG === "" || this.benutzer.emailG === null) return null;

      return this.emailRegex.test(this.benutzer.emailG) ? true : false;
    },
    benutzerValidation() {
      if (
        this.anmeldenameState &&
        this.vornameState &&
        this.nameState
      ) {
        return true;
      } else {
        return false;
      }
    },
    persoenlichesValidation() {
      if (
        this.geschlechtState &&
        this.vornameState &&
        this.nameState &&
        this.geburtstadumState
      ) {
        return true;
      } else {
        return false;
      }
    },
    anschriftValidation() {
      if (
        this.strasseState &&
        this.plzState &&
        this.ortState &&
        this.landState
      ) {
        return true;
      } else {
        return false;
      }
    },
    kontaktinformationValidation() {
      if (this.telState && this.emailState) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    ...mapActions([
      "adminUpdateBenutzer",
      "adminChangePasswort",
      "getBenutzerBild",
      "uploadBenutzerBild",
      "adminChangeFunctions",
      "adminSmsProvider",
      "adminDeleteBenutzer"
    ]),
    benutzerBearbeiten() {
      this.benutzer.geburtstag = this.date;
      this.adminUpdateBenutzer(this.benutzer).then(() => {
        this.date = "";

        const toastData = {
          title: "",
          msg: "Die Änderungen wurden gespeichert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg.response.data);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide("benutzerBearbeiten");
        // }
      });
    },
    passwortÄndern() {
      this.changePasswortData.altesPasswort = ""
      this.changePasswortData.userId = this.benutzer.id
      this.changePasswortData.neuesPasswort = this.benutzer.passwort

      this.adminChangePasswort(this.changePasswortData).then(() => {
        this.changePasswortData = {};

        const toastData = {
          title: "",
          msg: "Das Passwort wurde geändert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg.response.data);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`benutzerBearbeiten`);
        // }
      });
    },
    uploadBild() {
      var fd = new FormData();
      fd.append("file", this.file);
      this.uploadBenutzerBild(fd).then(() => {
        this.getBenutzerBild();

        this.file = null;

        const toastData = {
          title: "",
          msg: "Das Bild wurde gespeichert.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.kontakteStatus.errMsg.response.data);
          toastData.variant = "danger";
        }

        this.$emit("profilBearbeitenToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`profilBearbeiten`);
        // }
      });
    },
    createSmsProvider() {
      const smsProviderData = {
        userId: this.benutzer.id,
        smsHost: this.benutzer.smsHost || "",
        smsUserId: this.benutzer.smsUserId || "",
        smsApiKey: this.benutzer.smsApiKey || ""
        // smsProvider: this.benutzer.smsProvider
      };

      this.adminSmsProvider(smsProviderData).then(() => {
        const toastData = {
          title: "",
          msg: "Der SMS Provider wurde hinterlegt.",
          variant: "success"
        };

        if (this.adminStatus.errMsg) {
          (toastData.title = "Es ist etwas schief gelaufen."),
            (toastData.msg = this.adminStatus.errMsg.response.data);
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`benutzerBearbeiten`);
        // }
      });
    },
    saveFunctionChanges() {
      var funktionen = this.benutzer.funktionen;
      funktionen.benutzerId = this.benutzer.id;
      this.adminChangeFunctions(funktionen).then(() => {
        const toastData = {
          title: "Änderungen wurden gespeichert",
          msg: "Die Änderungen wurden gespeichert",
          variant: "success"
        };
        if (this.adminStatus.errMsg) {
          toastData.title = "Es ist etwas schief gelaufen.";
          toastData.msg = this.adminStatus.errMsg.response.data;
          toastData.variant = "danger";
        }

        this.$emit("updUserToast", toastData);

        // if (!this.adminStatus.errMsg) {
        //   this.$bvModal.hide(`benutzerBearbeiten`);
        // }
      });
    },
    benutzerLoeschen() {
      if (
        confirm("Sind Sie sicher, dass sie das Konto entgülig löschen wollen ?")
      ) {
        this.adminDeleteBenutzer(this.benutzer.id).then(() => {
          const toastData = {
            title: "",
            msg: "Das Benutzerkonto wurde erfolgreich gelöscht.",
            variant: "success"
          };
          if (this.adminStatus.errMsg) {
            toastData.title = "Es ist etwas schief gelaufen.";
            toastData.msg = this.adminStatus.errMsg;
            toastData.variant = "danger";
          }

          this.$emit("updUserToast", toastData);

          if (!this.adminStatus.errMsg) {
            this.$bvModal.hide(`benutzerBearbeiten`);
          }
        });
      }
    },
    printBenutzerAsPDF () {
      const doc = new jsPDF();
      var name = `${this.benutzer.id}_${this.benutzer.vorname}_${this.benutzer.name}.pdf`
      var benutzerDaten = `BENUTZER:\nAnmeldename: ${this.benutzer.anmeldename}\nName: ${this.benutzer.vorname} ${this.benutzer.name}\nE-Mail: ${this.benutzer.email || ""}\nPasswort: ${this.benutzer.passwort}\n`

      var benutzerGeraet = ``
      if (this.benutzer.geraete != null && this.benutzer.geraete.length > 0) {
        benutzerGeraet = `ROLLATOR:\n`
        for(var geraet of this.benutzer.geraete) {
          benutzerGeraet += `Name: ${geraet.geraetekennung}\nSigfox Device Id: ${geraet.sigfoxDeviceId}\n\n`
        }
      }

      var benutzerKontakte = ``
      if (this.benutzer.kontakte != null && this.benutzer.kontakte.length > 0) {
        benutzerKontakte += `KONTAKTE:\n`
        for(var kontakt of this.benutzer.kontakte) {
          benutzerKontakte += `Name: ${kontakt.vorname} ${kontakt.name}\nEmail: ${kontakt.email}\nMobilnummer: ${kontakt.mobil}\n\n`
        }
      }

      doc.text(`https://app.digi-roll.de/start\n\n${benutzerDaten}\n${benutzerGeraet}\n${benutzerKontakte}`, 10, 10)

      
      doc.save(name)
    },
  },
  data() {
    return {
      emailRegex: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
      date: "",
      changePasswortData: {},
      file: null
    };
  },
  mounted() {
    this.date = new Date(this.benutzer.geburtsdatum);
    this.date =
      this.date.getFullYear() +
      "-" +
      ("0" + (this.date.getMonth() + 1)).slice(-2) +
      "-" +
      ("0" + this.date.getDate()).slice(-2);
  }
};
</script>
